
import EditBase from "../EditBase"

class EditRectangle extends EditBase {

    constructor(options) {
        super(options);
    }
    checkHeightPoint() {
        return false;
    }
    //切换动态属性
    initProperty() {
        var $this = this;
        var coordinatesProperty = new $this.Cesium.CallbackProperty(function () {
            var coordinates = $this.Cesium.Rectangle.fromCartesianArray($this.plot.attrPlot["edit_positions"]);
            return coordinates;
        }, false)

        this.plot.rectangle.coordinates = coordinatesProperty;
    }

    leftDown(evt) {
        this.reset(); //拾取开始
        let pick = this.viewer.scene.pick(evt.position);
        var entity = this.getPickEnity(pick);
        if (entity && entity.attrPlot && entity.attrPlot["edit_keyFlag"] && entity.attrPlot["editGuid"] == this.editGuid) {
            this.pickPos = entity;
            this.lockCamera();//锁定相机
        }

        if (entity && entity.attrPlot && entity.attrPlot["edit_centerFlag"] && entity.attrPlot["editGuid"] == this.editGuid) {
            this.centerPos = entity;
            this.lockCamera();//锁定相机
        }
        if (entity && entity.attrPlot && entity.attrPlot["edit_rotationFlag"] && entity.attrPlot["editGuid"] == this.editGuid) {
            this.rotationPos = entity;
            this.plot.attrPlot['startPoint'] = entity.position.getValue();
            this.cloneKeyPos();
            this.lockCamera();//锁定相机
            this.plot.attrPlot['startRotation'] = this.plot.rectangle.rotation || 0;
        }
        if (entity && entity.attrPlot && entity.attrPlot["edit_heightFlag"] && entity.attrPlot["editGuid"] == this.editGuid) {
            this.heightPos = entity;
            this.lockCamera();//锁定相机
        }
    }

    rotationAll(position) {
        var PA = this.plot.attrPlot['startPoint'];
        var center = this.plot.attrPlot['center_cartesian3'];
        var startRotation = this.plot.attrPlot['startRotation'];
        var angleCur = this.getAngleCenterPointDir(center, position, PA);
        var angle = angleCur + startRotation;
        if (isNaN(angle)) {
            return;
        }
        let theta = angleCur * (180 / Math.PI);
        this.plot.rectangle.rotation = angle;
        this.plot.rectangle.stRotation = angle;
        var newPos = this.getRotateCenterPoint(center, PA, -theta);
        this.rotationPos.position.setValue(newPos); //更新旋转点

        // var positions = this.plot.attrPlot["edit_positions"];
        // var positions_copy = this.plot.attrPlot["edit_positions_copy"]
        // for (let i = 0; i < positions_copy.length; i++) {
        //     var p = positions_copy[i];
        //     var newPos = this.getRotateCenterPoint(center, p, -theta);
        //     //positions[i] = newPos;
        //     this.plot.attrPlot["edit_keyPos"][i].position.setValue(newPos);
        // }
    }

    // leftUp() {

    //     if (this.rotationPos) {
    //         var positions = this.plot.attrPlot["edit_positions"];
    //         var pos = this.plot.attrPlot["edit_keyPos"];
    //         for (let i = 0; i < pos.length; i++) {
    //             var newPos = pos[i].position.getValue();
    //             positions[i] = newPos;
    //         }
    //     }

    //     super.leftUp();

    // }

}

export default EditRectangle;